var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"bodybox"},[_c('el-header',[_c('Header',{on:{"change":_vm.change}})],1),_c('el-main',{staticClass:"mainbox"},[(_vm.show)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }